// S2 · Matriz de riesgo (audios de Carlos, 14-oct): a mayor riesgo, menos valor asegurado.
// Severidad baja / media / alta → se ocultan planes altos o baja el tope del rango. Nunca inventa primas.
import base from '../datos/matriz-riesgo.json';
import { PLANES } from './planes';

const CLAVE = 'mbm:matriz';
export const matrizBase = base;
export function matrizActual() {
  try {
    const m = JSON.parse(localStorage.getItem(CLAVE) || 'null');
    if (m && m.puntos) return m;
  } catch (e) { /* sin almacenamiento */ }
  return base;
}
export function guardarMatriz(m) {
  try { localStorage.setItem(CLAVE, JSON.stringify(m)); } catch (e) { /* sin almacenamiento */ }
  window.dispatchEvent(new Event('mbm-matriz'));
}
export function restaurarMatriz() {
  try { localStorage.removeItem(CLAVE); } catch (e) { /* sin almacenamiento */ }
  window.dispatchEvent(new Event('mbm-matriz'));
}

const partes = (v) => String(v || '').split(',').map((s) => s.trim()).filter(Boolean);

// Puntaje y detalle por respuesta (para el panel del asesor)
export function severidad(answers, m = matrizActual()) {
  const detalle = [];
  let total = 0;
  Object.entries(m.puntos).forEach(([preg, tabla]) => {
    partes(answers[preg]).forEach((resp) => {
      const pts = tabla[resp];
      if (pts) { total += pts; detalle.push([resp, pts]); }
    });
  });
  const nivel = total >= m.umbrales.alta ? 'alta' : total >= m.umbrales.media ? 'media' : 'baja';
  return { total, nivel, detalle, etiqueta: { baja: 'Baja', media: 'Media', alta: 'Alta' }[nivel] };
}

// Lo que el cliente puede comprar de un producto, según su severidad
export function opcionesPlan(id, answers, m = matrizActual()) {
  const pl = PLANES[id];
  if (!pl) return null;
  const sev = severidad(answers, m);
  const cfg = (m.productos || {})[id] || {};
  const lim = cfg[sev.nivel];
  if (pl.modo === 'caja') {
    const f = sev.nivel === 'baja' || lim == null ? 1 : Number(lim);
    const max = Math.max(pl.min, Math.round((pl.max * f) / pl.paso) * pl.paso);
    return { ...pl, max, maxFicha: pl.max, limitado: max < pl.max, sev };
  }
  let planes = pl.planes;
  if (pl.modo === 'lista_por_edad') planes = pl.bandas[answers.edad] || null;
  if (!planes) return { ...pl, planes: [], sinBanda: true, sev };
  const n = sev.nivel === 'baja' || lim == null ? planes.length : Math.max(1, Math.min(planes.length, Number(lim)));
  return { ...pl, planes: planes.slice(0, n), ocultos: planes.length - n, sev };
}

// Orden del comparador: primero el producto que responde a su mayor preocupación
export function ordenarPorPreocupacion(ids, answers, m = matrizActual()) {
  const primero = (m.preocupa_orden || {})[answers.preocupa];
  return primero && ids.includes(primero) ? [primero, ...ids.filter((x) => x !== primero)] : ids;
}
